import { render, staticRenderFns } from "./InfoWeCalculated.vue?vue&type=template&id=d30f4f94&scoped=true"
import script from "./InfoWeCalculated.vue?vue&type=script&lang=ts"
export * from "./InfoWeCalculated.vue?vue&type=script&lang=ts"
import style0 from "./InfoWeCalculated.vue?vue&type=style&index=0&id=d30f4f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30f4f94",
  null
  
)

export default component.exports